import(/* webpackMode: "eager" */ "/home/runner/work/play-web/play-web/web/apps/offspring/src/app/(app)/(main)/layout.tsx");
